import { BaseServiceDefinition } from './BaseService';
import { Helpers } from '@/utils/Helpers';

class ChartReportsServiceDefinition extends BaseServiceDefinition {

    getChartReports(year: number, trapGroupId: string): Promise<any> {
        const query = Helpers.GetFakeDataQueryString();
        return this.get('/api/v1/chartReports/' + year + '/' + trapGroupId + query);
    }
}

export const ChartReportsService: ChartReportsServiceDefinition
    = new ChartReportsServiceDefinition();